import React from 'react';
import { useCart } from './CartContext';
import './Cart.css';
import { useNavigate, Link  } from "react-router-dom";
import { FaArrowLeft, FaShoppingBag } from 'react-icons/fa';

const Cart = () => {
    const { cart, removeFromCart, updateQuantity, clearCart } = useCart();
    const navigate = useNavigate();
  
    const formatPrice = (price) => {
      const numericPrice = Number(price) || 0;
      return numericPrice.toFixed(2);
    };

    const handleCheckout = () => {
      // Navigate to checkout page with cart items as state
      navigate('/checkout', { 
        state: { 
          items: cart,
          total: cart.reduce((total, item) => total + (Number(item.price) * item.quantity), 0)
        } 
      });
    };

    const calculateTotal = () => {
      return cart.reduce((total, item) => total + (Number(item.price) * item.quantity), 0);
    };
  
    return (
      <div className="cart">
        <div className="cart-header-with-nav">
          <h2>Your Cart ({cart.length})</h2>
          <Link 
            to="/" 
            className="continue-shopping-btn"
          >
            <FaArrowLeft /> Continue Shopping
          </Link>
        </div>

        <div className="cart-header">
          <h2>Your Cart ({cart.length})</h2>
          {cart.length > 0 && (
            <div className="cart-actions">
              <button 
                onClick={clearCart}
                className="clear-cart-btn"
              >
                Clear Cart
              </button>
              <button
                onClick={handleCheckout}
                className="btn-buy-now"
                disabled={cart.length === 0}
              >
                Buy Now
              </button>
            </div>
          )}
        </div>
        
        {cart.length === 0 ? (
          <div className="empty-cart">
            <p>Your cart is empty</p>
            <Link 
              to="/" 
              className="start-shopping-btn"
            >
              <FaShoppingBag /> Start Shopping
            </Link>
          </div>
          
        ) : (
          <>
            <div className="cart-items">
              {cart.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="item-info">
                    <h4>{item.name}</h4>
                    <p>₹{item.price.toFixed(2)} × {item.quantity} = 
                      <strong> ₹{(item.price * item.quantity).toFixed(2)}</strong>
                    </p>
                  </div>
                  <div className="quantity-controls">
                    <button 
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      disabled={item.quantity <= 1}
                      className="quantity-btn minus-btn"
                    >
                      -
                    </button>
                    <span className="quantity-display">{item.quantity}</span>
                    <button 
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      className="quantity-btn plus-btn"
                    >
                      +
                    </button>
                    <button 
                      onClick={() => removeFromCart(item.id)}
                      className="remove-btn"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="cart-total">
              <h3>Total: ₹{formatPrice(calculateTotal())}</h3>
            </div>
          </>
        )}
      </div>
    );
};

export default Cart;